var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBank(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_13_567)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.29119 6.2893H10.6973V9.65624H9.29119V6.2893ZM6.62829 6.2893H8.03454V9.65624H6.62829V6.2893ZM3.96537 6.2893H5.37162V9.65624H3.96537V6.2893ZM1.30256 6.2893H2.70872V9.65624H1.30256V6.2893ZM11.1662 5.23461V4.88305H0.833813V5.23461C0.833813 5.42879 0.991195 5.58617 1.18538 5.58617H10.8146C11.0087 5.58617 11.1662 5.42879 11.1662 5.23461ZM11.6482 10.3594H0.351891C0.157688 10.3594 0.000328247 10.5167 0.000328247 10.7109V11.6484C0.000328247 11.8426 0.157688 12 0.351891 12H11.6482C11.8424 12 11.9998 11.8426 11.9998 11.6484V10.7109C11.9998 10.5167 11.8424 10.3594 11.6482 10.3594ZM0.351516 4.17992H11.6484C11.7249 4.17992 11.7994 4.15494 11.8604 4.10878C11.9215 4.06261 11.9658 3.99778 11.9867 3.92413C12.0075 3.85048 12.0038 3.77204 11.976 3.70072C11.9482 3.6294 11.8979 3.56909 11.8327 3.52897L6.18424 0.0521817C6.12883 0.0180646 6.06503 0 5.99995 0C5.93488 0 5.87108 0.0180646 5.81566 0.0521817L0.167227 3.52897C0.102049 3.5691 0.0517491 3.6294 0.0239694 3.70073C-0.00381038 3.77205 -0.0075521 3.85049 0.0133126 3.92413C0.03416 3.99776 0.0784673 4.06259 0.139507 4.10876C0.200546 4.15492 0.274984 4.17991 0.351516 4.17992ZM5.76101 2.06781H6.23899C6.43317 2.06781 6.59056 2.22517 6.59056 2.41937C6.59056 2.61355 6.43317 2.77093 6.23899 2.77093H5.76101C5.56683 2.77093 5.40945 2.61355 5.40945 2.41937C5.40945 2.22517 5.56683 2.06781 5.76101 2.06781Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_13_567"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 12,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBank);
export default __webpack_public_path__ + "static/media/bank.2bf9fc408bada987541262f63ae855d0.svg";
export { ForwardRef as ReactComponent };